module.exports = __webpack_public_path__ + "static/media/ripple.7a987334.gif";